import type React from "react";

import {faClone} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import CustomButton from "~/component/common/CustomButton";

import {useEditActions} from "../hooks/useEditActions";

const DuplicateSelectionButton: React.FC = () => {
  const {handleDuplicate} = useEditActions();

  return (
    <>
      <CustomButton
        onClick={handleDuplicate}
        aria-label="Duplicate selection"
        className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
      >
        <FontAwesomeIcon
          icon={faClone}
          size="xl"
          className="text-white p-2 -m-2 rounded-full pl-2 pr-2 bg-gradient-to-br from-green-600 via-green-500 to-black"
        />
      </CustomButton>
    </>
  );
};

export default DuplicateSelectionButton;
